import { Link } from 'react-router-dom';

const footerLinks = {
  分类导航: [
    { label: '安全访问', href: '/category/safe-access' },
    { label: '隐私保护', href: '/category/privacy-protection' },
    { label: '内容分级', href: '/category/content-filtering' },
    { label: '合规使用', href: '/category/compliance' },
    { label: '家庭防护', href: '/category/family-safety' },
    { label: '数字健康', href: '/category/digital-wellness' },
  ],
  关于我们: [
    { label: '品牌介绍', href: '/about' },
    { label: '联系方式', href: '/about#contact' },
    { label: '隐私政策', href: '/about#privacy' },
  ],
  热门文章: [
    { label: '安全访问完全指南', href: '/article/safe-access-complete-guide' },
    { label: '浏览器隐私模式解析', href: '/article/browser-privacy-mode-explained' },
    { label: '法律法规解读', href: '/article/china-law-adult-website-compliance' },
    { label: '家庭网络过滤教程', href: '/article/family-network-filtering-tutorial' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-shield-check-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-semibold text-foreground-900 font-heading">
                安全指南
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              致力于提供成人网站安全访问、隐私保护与内容分级的专业指导，帮助用户建立安全、健康的网络使用习惯。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 安全指南. 本站内容仅供成年人参考，请遵守当地法律法规。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors" aria-label="RSS" rel="nofollow">
              <i className="ri-rss-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}